import { motion } from "framer-motion";
import PageHeader from "@/components/PageHeader";

const manifesto = [
  {
    n: "01",
    text: "I got interested in music long before I got interested in being seen making it. The composition was always the point. Everything around it came later.",
  },
  {
    n: "02",
    text: "Some ideas fit inside a sentence. Others need forty minutes of harmony, rhythm, distortion, silence and repetition before they make any sense. Those become records.",
  },
  {
    n: "03",
    text: "Genre is just the room a piece happens to stand in. I care about the world it builds, and whether it can hold a feeling that words keep missing.",
  },
];

const credits = [
  { role: "Composition & Production", name: "ØČËĀŃ", span: "md:col-span-8", big: true },
  { role: "Additional Production", name: "NIKOTHEGREAT", span: "md:col-span-4" },
  { role: "Mixing", name: "OLYMPUSSTUDIOS", span: "md:col-span-4" },
  { role: "Mastering", name: "OLYMPUSSTUDIOS", span: "md:col-span-4" },
  { role: "Artwork & Direction", name: "ØČËĀŃ", span: "md:col-span-4" },
  { role: "Label", name: "IMMORTAL MULTIMEDIA GROUP", span: "md:col-span-12" },
];

export default function Credits() {
  return (
    <div data-testid="credits-page" className="min-h-screen">
      <PageHeader
        chapter="The Archive · About Ø"
        title="About"
        intro="Not a biography. Closer to the thinking behind the worlds."
      />

      {/* Manifesto */}
      <div className="px-6 md:px-12 pb-24 max-w-[1500px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-14 md:gap-10">
          {manifesto.map((m, i) => (
            <motion.div
              key={m.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              data-testid={`manifesto-${m.n}`}
              className="md:col-span-4"
            >
              <p className="font-mono text-[11px] tracking-[0.4em] text-[#8a8a8a] mb-5">{m.n}</p>
              <p className="font-serif text-2xl md:text-[1.7rem] leading-[1.4] text-[#e5e2dc]">{m.text}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Credits */}
      <div className="px-6 md:px-12 pb-40 max-w-[1500px] mx-auto">
        <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-[#8a8a8a] mb-6">Hands on the archive</p>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-px bg-white/10 border border-white/10">
          {credits.map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              data-testid={`credit-${i}`}
              className={`${c.span} bg-[#080808] p-8 md:p-12 hover:bg-[#0e0e0e] transition-colors duration-500`}
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-[#8a8a8a] mb-4">{c.role}</p>
              <p className={`font-serif tracking-tight text-[#f2f0ec] ${c.big ? "text-5xl md:text-7xl" : "text-3xl md:text-4xl"}`}>
                {c.name}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
